import { isGUID } from '@client/shared/utils/utils/utils';
import httpRequest from './httpRequest';
import { getBaseRequestConfig, LOCAL_BASE_PATH } from './baseRequestConfig';

export function putFundraiser(fundraiser, fundraiserId, accessToken) {
  // Omit Content-Type so Axios sets proper multipart boundary for FormData
  const baseRequestConfig = getBaseRequestConfig(accessToken, null);
  const url = `${LOCAL_BASE_PATH}/fundraiser/${fundraiserId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: fundraiser,
  });

  return httpRequest(requestConfig);
}

export function putFundraiserDates(fundraiser, fundraiserId, accessToken) {
  // Omit Content-Type so Axios sets proper multipart boundary for FormData
  const baseRequestConfig = getBaseRequestConfig(accessToken, null);
  const url = `${LOCAL_BASE_PATH}/fundraiser/${fundraiserId}/setDates`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
    data: fundraiser,
  });

  return httpRequest(requestConfig);
}

export function postFundraiser(fundraiser, accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/fundraiser`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: fundraiser,
  });

  return httpRequest(requestConfig);
}

export function sendShareByEmail(recaptcha, fundraiserId, email) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/fundraiser/${fundraiserId}/shareByEmail`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: Object.assign({}, email, { googleReCaptchaToken: recaptcha }),
  });

  return httpRequest(requestConfig);
}

export function fetchFundraisers(queryParams = '') {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/fundraiser${queryParams}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function fetchMyFundraisers(accessToken) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/fundraiser/my`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function fetchFundraiser(slug) {
  const baseRequestConfig = getBaseRequestConfig();
  const urlSegment = isGUID(slug) ? `${slug}` : `slug/${slug}`;

  const url = `${LOCAL_BASE_PATH}/fundraiser/${urlSegment}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}
